const data = {
  columns: [
    {
      prop: 'index',
      label: '排名'
    }, {
      prop: 'siteName',
      label: '站点名称',
      width: '200'
    }, {
      prop: 'rentNum',
      label: '租车',
      renderHeaderType: 'rentNum'
    }, {
      prop: 'returnNum',
      label: '还车',
      renderHeaderType: 'returnNum'
    }
  ]
}

export default data
